import {
    DOWNLOADING,
    ERROR,
    ERROR_TOTALS,
    GET_PERMANENCE_REPORT,
    GET_PERMANENCE_REPORT_TOTALS,
    IS_FETCHING_TOTALS,
    SET_FILTER,
    SET_PERMANENCE_REPORT_LOADING
} from "./types";

const PermanenceReportReducer = (state, action) => {

    const { payload, type } = action;

    switch (type) {
        case SET_FILTER:
            return {
                ...state,
                isFetching: true,
                error: false,
                reportFilter: payload,
            };
        case SET_PERMANENCE_REPORT_LOADING:
            return {
                ...state,
                isFetching: true,
                error: false,
                message: '',
                reports: [],
                totalPages: null
            };
        case GET_PERMANENCE_REPORT:
            return {
                ...state,
                isFetching: false,
                error: false,
                reports: payload.reports,
                totalPages: payload.totalPages,
                headers: payload.headers
            };
        case ERROR:
            return {
                ...state,
                isFetching: false,
                error: true,
                message: payload,
            };
        case IS_FETCHING_TOTALS:
            return {
                ...state,
                isFetchingTotalsReports: true,
            };
        case GET_PERMANENCE_REPORT_TOTALS:
            return {
                ...state,
                totalsReports: payload.totalsReports,
                totalReport: payload.totalReport,
                isFetchingTotalsReports: false,
            };
        case ERROR_TOTALS:
            return {
                ...state,
                isFetchingTotalsReports: true,
            };
        case DOWNLOADING:
            return {
                ...state,
                isDownloadingReport: payload.isDownloadingReport,
                downloadError: payload.downloadError,
                downloadMessage: payload.downloadMessage
            };
        default:
            return state;
    }
}

export default PermanenceReportReducer